import { NgModule } from '@angular/core';
import { LayoutsModule } from './presentation/layouts/layouts.module';
import { ComissoesModule } from './presentation/pages/comissoes/comissoes.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { PrimecapComponent } from './presentation/primecap-view/primecap-view.component';
import { PrimecapRoutingModule } from './primecap-routing.module';

import { HomeComponent } from './presentation/pages/home/home.component';
import { RodadasComponent } from './presentation/pages/rodadas/rodadas.component';
import { InvestidoresComponent } from './presentation/pages/investidores/investidores.component';
import { PushComponent } from './presentation/pages/push/push.component';
import { AssessoresComponent } from './presentation/pages/assessores/assessores.component';


@NgModule({
  declarations: [
    PrimecapComponent,
    HomeComponent,
    RodadasComponent,
    InvestidoresComponent,
    PushComponent,
    AssessoresComponent,
  ],
  imports: [
    PrimecapRoutingModule,
    SharedModule,
    LayoutsModule,
    ComissoesModule
  ],
  exports: [PrimecapComponent]
})
export class PrimecapModule { }
